import {
  Avatar,
  Button,
  Divider,
  Dropdown,
  FormControl,
  FormLabel,
  Menu,
  MenuButton,
  MenuItem,
  Radio,
  Stack,
  Typography,
} from '@mui/joy';
import { FiPlusCircle } from 'react-icons/fi';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';

import { ProfileMenuItem } from './hooks/useNavbarState';

interface DesktopProfileMenuProps {
  isHoveringOverProfile: boolean;
  setIsHoveringOverProfile: (v: boolean) => void;
  userInfo: any;
  themeOptionsList: Array<{ label: string; value: 'light' | 'dark' }>;
  envOptionsList: Array<{ label: string; value: boolean }>;
  mode: string | undefined;
  isCalyxTeamMember: boolean;
  appIsStaging: boolean;
  filterState: any;
  followingProjectsCount: number | undefined;
  isLoading: boolean;
  profileMenuConfig: ProfileMenuItem[];
  followingUrl: string;
  handleThemeSwitch: (mode: 'dark' | 'light') => void;
  handleEnvToggle: () => void;
  handleFollowingClick: () => void;
  StyledLink: any;
}

export const DesktopProfileMenu = ({
  isHoveringOverProfile,
  setIsHoveringOverProfile,
  userInfo,
  themeOptionsList,
  envOptionsList,
  mode,
  isCalyxTeamMember,
  appIsStaging,
  followingProjectsCount,
  isLoading,
  profileMenuConfig,
  followingUrl,
  handleThemeSwitch,
  handleEnvToggle,
  handleFollowingClick,
  StyledLink,
}: DesktopProfileMenuProps) => {
  return (
    <div
      onMouseEnter={() => setIsHoveringOverProfile(true)}
      onMouseLeave={() => setIsHoveringOverProfile(false)}
      style={{ padding: '3px 0px', margin: '-3px 0px' }}
    >
      <Dropdown>
        <MenuButton variant='plain' color='primary'>
          <Stack direction={'row'} alignItems={'center'} gap={1}>
            <Avatar
              alt={`${userInfo?.name}`}
              src={`${userInfo?.profile_image}`}
              variant='outlined'
              color='primary'
            />
            <Typography fontSize={'md'} fontWeight={'md'} color='primary'>
              My Account
            </Typography>
            {isHoveringOverProfile ? <IoChevronUp /> : <IoChevronDown />}
          </Stack>
        </MenuButton>
        <Menu variant='outlined' sx={{ minWidth: '200px' }} open={isHoveringOverProfile}>
          <FormControl sx={{ mb: 1 }}>
            <FormLabel sx={{ paddingX: 1, fontWeight: 'xl', fontSize: 'sm' }}>Appearance</FormLabel>
            {themeOptionsList.map(({ label, value }) => (
              <MenuItem key={value} onClick={() => handleThemeSwitch(value)}>
                <Radio
                  value={value}
                  variant='outlined'
                  size='md'
                  color='primary'
                  sx={{ fontSize: 'md' }}
                  checked={mode === value}
                />
                <Typography fontSize={'md'} fontWeight={'sm'}>
                  {label}
                </Typography>
              </MenuItem>
            ))}
          </FormControl>
          {isCalyxTeamMember ? (
            <FormControl sx={{ mb: 1 }}>
              <FormLabel sx={{ paddingX: 1, fontWeight: 'xl', fontSize: 'sm' }}>
                App Environment
              </FormLabel>
              {envOptionsList.map(({ label, value }) => (
                <MenuItem key={label} onClick={handleEnvToggle}>
                  <Radio
                    value={value}
                    variant='outlined'
                    size='md'
                    color='primary'
                    sx={{ fontSize: 'md' }}
                    checked={appIsStaging === value}
                  />
                  <Typography fontSize={'md'} fontWeight={'sm'}>
                    {label}
                  </Typography>
                </MenuItem>
              ))}
            </FormControl>
          ) : null}
          <Divider />
          <MenuItem onClick={handleFollowingClick}>
            <StyledLink to={followingUrl} sx={{ height: (theme) => theme.spacing(4) }}>
              <Button
                size='md'
                variant='plain'
                color='primary'
                startDecorator={<FiPlusCircle size={20} />}
                sx={{ padding: 0 }}
              >
                <Typography fontSize={'md'} fontWeight={'sm'}>
                  Following ({isLoading ? '...' : followingProjectsCount})
                </Typography>
              </Button>
            </StyledLink>
          </MenuItem>
          {profileMenuConfig.map(({ onClick, title, show }) => {
            if (!show) return null;
            return (
              <div key={title}>
                <Divider />
                <MenuItem onClick={onClick}>
                  <Typography fontSize={'md'} fontWeight={'sm'}>
                    {title}
                  </Typography>
                </MenuItem>
              </div>
            );
          })}
        </Menu>
      </Dropdown>
    </div>
  );
};
